<template>
    <main class="main-content main-content-case-news last-news-page">
        <div class="container-fluid container-specials">
            <div class="row">
                <div class="col-12">
                    <p class="specials-title"><strong>ÚLTIMAS NOTÍCIAS</strong></p>
                </div>
            </div>
        </div>

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container" v-if="!news.length">
            <div class="row">
                <div class="col-12">
                    <content-loader 
                        class="d-none d-lg-block"
                        style="margin: 40px auto; display:block"
                        width="1100"
                        height="950">

                        <template v-for="(index,i) in 8">
                            <rect x="1" :y="1+(i*120)" rx="0" ry="0" width="160" height="104" :key="`image-${i}`" />
                            <rect x="180" :y="1+(i*120)" rx="0" ry="0" width="186" height="14" :key="`date-${i}`" /> 
                            <rect x="180" :y="25+(i*120)" rx="0" ry="0" width="549" height="16" :key="`title-${i}`" /> 
                            <rect x="180" :y="50+(i*120)" rx="0" ry="0" width="549" height="23" :key="`description-${i}`" /> 
                        </template>
                    </content-loader>

                    <content-loader 
                        class="d-none d-md-block d-lg-none"
                        style="margin: 40px auto; display:block"
                        width="1100"
                        height="950">

                        <template v-for="(index,i) in 5">
                            <rect x="1" :y="1+(i*190)" rx="0" ry="0" width="240" height="150" :key="`image-${i}`" />
                            <rect x="270" :y="1+(i*190)" rx="0" ry="0" width="186" height="14" :key="`date-${i}`" /> 
                            <rect x="270" :y="45+(i*190)" rx="0" ry="0" width="850" height="16" :key="`title-${i}`" /> 
                            <rect x="270" :y="70+(i*190)" rx="0" ry="0" width="850" height="23" :key="`description-${i}`" /> 
                        </template>
                    </content-loader>

                    <content-loader 
                        class="d-lg-none d-xl-none d-sm-block d-md-none"
                        style="margin: 40px auto; display:block"
                        width="1100"
                        height="1150">

                        <template v-for="(index,i) in 3">
                            <rect x="1" :y="1+(i*380)" rx="0" ry="0" width="540" height="350" :key="`image-${i}`" />
                            <rect x="570" :y="1+(i*380)" rx="0" ry="0" width="286" height="24" :key="`date-${i}`" /> 
                            <rect x="570" :y="55+(i*380)" rx="0" ry="0" width="500" height="96" :key="`title-${i}`" /> 
                        </template>
                    </content-loader>
                </div>
            </div>
        </div>

        <div class="container container-noticies-block" v-else>
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="row" v-for="n in news" :key="n.id">
                        <div class="col-12">
                            <router-link 
                                class="noticies-item noticies-item--nofloat noticies-item--img-small"
                                :to="n.url">
                                <div class="noticies-item--image" >
                                    <img v-if="n.image" :src="utils.image(n.image, width=160, height=104)" alt="" />
                                    <img v-else src="@/assets/images/search-placeholder.jpg" />
                                </div>
                                <div class="noticies-item--info">
                                    <p class="noticies__label"><strong>{{utils.date(n.meta.first_published_at)}} - {{n.editorial.title}}</strong></p>
                                    <p class="noticies__title noticies__title--white"><strong>{{n.title}}</strong></p>
                                    <p class="noticies__text">{{n.subtitle}}</p>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-12">
                            <Pagination :count="count" :limit="limit" />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div id='div-gpt-ad-1603502104885-0'></div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import page from '@/api/page'
import utils from '@/utils'

import Pagination from '@/components/Pagination'

import { ContentLoader } from 'vue-content-loader'

export default {
    name: 'Ultimas',
    components:{Pagination, ContentLoader},
    head:{
        title:{
            inner: 'Últimas Notícias'
        }
    },
    data: function () {
        return {
            news: [],
            utils: utils,
            count: 0,
            limit: 10,
            pagination: {}
        }
    },
    watch: {
        '$route.query': function () {
            this.load_news()
        }
    },
    methods: {
        reset() {
            this.news = []
        },
        async load_news() {
            this.reset()
            const response = await page.list(
                'news.NewsPage', 
                'subtitle,editorial,image,url', 
                this.$route.query.page,
                this.limit
            )
            this.news = response.data.items
            this.count = response.data.meta.total_count
        }
    },
    created() {
        this.load_news()
    },
    mounted() {
        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.defineSlot('/1513505/v1_gweb_arroba_lateral', [300, 250], 'div-gpt-ad-1603502104885-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices();
            googletag.display('div-gpt-ad-1603501550614-0');
            googletag.display('div-gpt-ad-1603502104885-0');
        })
        window._ppads.checksBeforeLoad()
    }
}
</script>